import { ID_TYPE_PRODUCT_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { ComparisonButton } from '@widgets/ProductCard/ui/ComparisonButton/ComparisonButton';

import { CartButton } from './CartButton/CartButton';
import { FavoriteButton } from './FavoriteButton/FavoriteButton';
import cls from './Controls.module.scss';

export const Controls = () => {
  const id = useAppSelector((state) => state.product.data.id);
  const category = useAppSelector(
    (state) => state.product.data.props[ID_TYPE_PRODUCT_ATTRIBUTE]?.values?.[0]?.value ?? ''
  );

  return (
    <div className={cls.wrap}>
      <CartButton />
      <FavoriteButton />
      <ComparisonButton
        className={cls.icon}
        id={id}
        category={category}
      />
    </div>
  );
};
